import * as Store from '../../weborder/Store';
import { CustomStyleConfig } from '../style.types.d';
import { createTheme } from '../ThemeProvider';

export const createAlphaTheme = () => {
  const store = Store.getStoreInstance();
  const state = store.getState();

  // Load weborder stylesheet if weborder
  if (process.env.REACT_APP_PLATFORM !== 'portal') {
    require('../../weborder/index.scss');
  }

  const appDesignScheme: CustomStyleConfig = {
    background: '#FFFFFF',
    darkBackground: state.appDesignScheme.Secondary,
    fontFamily: state.appDesignScheme.Font
      ? state.appDesignScheme.Font
      : 'Roboto',
    isDark: state.flipdish.isDark,
    primary: state.appDesignScheme.Secondary,
  };

  return createTheme({
    overrides: {
      MuiIcon: {
        // fa icons getting cut
        fontSizeLarge: {
          overflow: 'visible',
        },
      },
    },

    palette: {
      type: appDesignScheme.isDark ? 'dark' : 'light',
      primary: {
        main: appDesignScheme.primary,
        contrastText: '#fff', // TEMP until we remove all Radium & convert to material-ui
      },
      background: {
        default: appDesignScheme.isDark
          ? appDesignScheme.darkBackground
          : appDesignScheme.background,
      },
    },

    typography: {
      fontFamily: [`'${appDesignScheme.fontFamily}'`, 'sans-serif'].join(','),
      fontSize: 14,

      h1: {
        fontSize: '36px',
        fontWeight: 400,
        lineHeight: 1.1,
      },
      h2: {
        fontFamily: appDesignScheme.fontFamily,
        fontSize: '30px',
        fontWeight: 400,
        lineHeight: 1.1,
      },
      h3: {
        fontFamily: appDesignScheme.fontFamily,
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: 1.1,
      },
      h4: {
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: 1.1,
      },
      h5: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: 1.1,
      },
      h6: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 1.1,
      },
      body1: {
        fontSize: '16px',
      },
      body2: {
        fontSize: '16px',
      },
      fontWeightBold: 700,
      button: {
        textTransform: 'none',
        fontWeight: 400,
        fontSize: '16px',
      },
      caption: {
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.33',
        color: '#888',
      },
    },

    zIndex: {
      mobileStepper: 101000,
      appBar: 101100,
      drawer: 101200,
      modal: 101300,
      snackbar: 101400,
      tooltip: 101500,
    },
  });
};
